export const useWatchOnce = (source, callback, options = {}) => {
  const stop = watch(
    source,
    (newValue, oldValue) => {
      callback(newValue, oldValue);
      stop(); // Stops the watcher after the first execution
    },
    options
  );
};
